import gele from './gele.js';

/**
 * Gtle.
 *
 * @param {number} m
 * @param {number} n
 * @param {Iterable} iterable
 */
const gtle = (m, n, iterable) => gele(m + 1, n, iterable);
export default gtle;
